import React, { Suspense, useMemo } from "react";
import * as THREE from "three";
import { useTexture } from "@react-three/drei";

function Inner({ url, args, position, rotation, opacity, emissive, tone }) {
  const tex = useTexture(url);
  const mat = useMemo(() => {
    if (emissive) {
      return new THREE.MeshBasicMaterial({ map: tex, transparent: opacity < 1, opacity, toneMapped: tone !== false });
    }
    return new THREE.MeshStandardMaterial({ map: tex, roughness: 0.9, transparent: opacity < 1, opacity });
  }, [tex, opacity, emissive, tone]);
  return (
    <mesh position={position} rotation={rotation} material={mat}>
      <planeGeometry args={args} />
    </mesh>
  );
}

// Archival photo mapped onto a plane (material anchor). Wrapped in Suspense.
export default function PhotoPlane({ url, args = [8, 5], position = [0, 2, -5], rotation = [0, 0, 0], opacity = 1, emissive = false, tone }) {
  return (
    <Suspense fallback={null}>
      <Inner url={url} args={args} position={position} rotation={rotation} opacity={opacity} emissive={emissive} tone={tone} />
    </Suspense>
  );
}
